import React from "react";

const Button = ({buttonText, buttonAction}) => {
  return(
    <>
      <button 
        type="button" 
        className="max-h-6 text-blue-700 border border-black bg-gradient-to-t from-gray-400 to-white hover:bg-gradient-to-br font-bold px-2.5 me-2"
        onClick={buttonAction}
      >
        {buttonText}
      </button>
    </>
  )
}

export default Button;